import React from 'react';
export function BrandName({
  className = ''
}: {
  className?: string;
}) {
  return <span className={className} data-id="element-38">SalesUp</span>;
}